import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Alert } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { chatsAPI } from '../../services/chatsApi'

const CreateChatModal = ({ show, onHide, project }) => {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [error, setError] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (show && project) {
      setName(`Чат: ${project.address}`)
      setError(null)
    }
  }, [show, project])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!name.trim()) {
      setError('Введите название чата')
      return
    }

    try {
      setSaving(true)
      const response = await chatsAPI.create({ name: name.trim(), project_id: project.id })
      window.dispatchEvent(new Event('chats:updated'))
      onHide()
      navigate(`/chats/${response.data.id}`)
    } catch (err) {
      console.error('Error creating chat:', err)
      setError('Не удалось создать чат')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Создать чат</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group>
            <Form.Label>Название чата</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Отмена
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving ? 'Создание...' : 'Создать'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default CreateChatModal
